import {
    GET_PARAINAGES,
    API_RESPONSE_SUCCESS,
    API_RESPONSE_ERROR,
  
    UPDATE_PARAINAGE,
    UPDATE_PARAINAGE_SUCCESS,
    UPDATE_PARAINAGE_FAIL,
    
    ADD_NEW_PARAINAGE,
    ADD_PARAINAGE_SUCCESS,
    ADD_PARAINAGE_FAIL,

  } from "./actionType";

  // common success
  export const parainageApiResponseSuccess = (actionType, data) => ({
    type: API_RESPONSE_SUCCESS,
    payload: { actionType, data },
  });
  // common error
  export const parainageApiResponseError = (actionType, error) => ({
    type: API_RESPONSE_ERROR,
    payload: { actionType, error },
  });
  
  export const getParainages = () => ({
    type: GET_PARAINAGES,
  });

  export const updateParainage = parainage => ({
    type: UPDATE_PARAINAGE,
    payload: parainage,
  });
  
  export const updateParainageSuccess = parainage => ({
    type: UPDATE_PARAINAGE_SUCCESS,
    payload: parainage,
  });
  
  export const updateParainageFail = error => ({
    type: UPDATE_PARAINAGE_FAIL,
    payload: error,
  });
  
  export const addNewParainage = parainage => ({
    type: ADD_NEW_PARAINAGE,
    payload: parainage,
  });
  
  export const addParainageSuccess = parainage => ({
    type: ADD_PARAINAGE_SUCCESS,
    payload: parainage,
  });
  
  export const addParainageFail = error => ({
    type: ADD_PARAINAGE_FAIL,
    payload: error,
  });